import React from 'react';
import { func } from 'utils';

const Oops = () => {
	const { maps } = Object(window).google || {};

	return (
		<React.Fragment>
			<div
				className="text-center p-3 d-flex justify-content-center align-items-center"
				style={{ height: '75vh' }}
			>
				<div>
					<div className="primary-light fw-600 m-0" style={{ fontSize: 80 }}>
						Ouch!
					</div>
					{maps ? (
						<>
							<div className="fw-500" style={{ fontSize: 18 }}>
								Sorry, we do not deliver here
							</div>
							<div className="text-muted">
								We're expanding quickly so please do check back soon!
							</div>
						</>
					) : (
						<>
							<div className="text-muted">
								Sorry, we were unable to load google maps.
							</div>
							<div className="fw-500 mt-2" style={{ fontSize: 18 }}>
								Kindly{' '}
								{func.isMobile
									? 'exit and reopen the app'
									: 'refresh the browser'}
								.
							</div>
						</>
					)}
				</div>
			</div>
		</React.Fragment>
	);
};

export default Oops;
